import { SxStyleProp } from 'theme-ui';

export const Container: SxStyleProp = {
  paddingBottom: ['40px', null, '50px'],
  paddingX: ['34px', 'initial'],
};

export const Title: SxStyleProp = {
  textAlign: 'center',
  maxWidth: ['307px', '1352px'],
  mx: 'auto',
};

export const Grid: SxStyleProp = {
  columnGap: [null, '40px', null, null, null, '60px'],
  rowGap: ['43px'],
  marginTop: ['48px', '78px'],
};
